import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "../site/motion";
import { CHAPTERS } from "../site/data";

const Chapter = ({ ch, index }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const flip = index % 2 === 1;

  return (
    <div ref={ref} data-testid={`chapter-${ch.no}`} className="relative grid grid-cols-1 md:grid-cols-12 gap-8 items-center py-16 md:py-24">
      <div className={`md:col-span-6 relative ${flip ? "md:order-2" : ""}`}>
        <div className="overflow-hidden clip-frame border border-border">
          <motion.img style={{ y }} src={ch.img} alt={ch.title} className="w-full h-[380px] md:h-[560px] object-cover scale-110" />
        </div>
      </div>
      <div className={`md:col-span-6 relative ${flip ? "md:order-1 md:pr-16" : "md:pl-16"}`}>
        <span className="pointer-events-none absolute -top-24 md:-top-28 left-0 font-serif font-light text-muted select-none text-[9rem] md:text-[14rem] leading-none">
          {ch.no}
        </span>
        <Reveal className="relative">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-secondary mb-5">Chapter {ch.no}</p>
          <h3 className="font-serif font-light text-foreground text-4xl md:text-6xl mb-6">{ch.title}</h3>
          <p className="text-muted-foreground text-lg leading-relaxed max-w-md">{ch.body}</p>
        </Reveal>
      </div>
    </div>
  );
};

export const Manifesto = () => (
  <section id="approach" data-testid="manifesto-section" className="bg-background pt-16 pb-16 md:pt-24">
    <div className="mx-auto max-w-[1600px] px-6 md:px-10">
      <Reveal className="mb-4 md:mb-10">
        <p className="text-xs font-semibold uppercase tracking-[0.24em] text-secondary">How We Care</p>
        <h2 className="font-serif font-light text-foreground text-4xl md:text-6xl mt-4">The path forward, in three chapters.</h2>
      </Reveal>
      {CHAPTERS.map((ch, i) => (
        <Chapter key={ch.no} ch={ch} index={i} />
      ))}
    </div>
  </section>
);
